import { DEFAULT_COLORS } from "@nens/ranalib";
import {
  capitalizeAll,
  hexToRgb,
  objectEntries,
  objectFromEntries,
  satisfiesRecord,
} from "@nens/shared-utils";

type Color = [number, number, number] | [number, number, number, number];

// Convert flat brand colors to uppercase RGB tuples for use in deck.gl layers.
// Each entry is a [colorName, hexString] tuple, e.g. ["clear_creek", "#69a0c9"].
// Nested objects (e.g. the "grey" palette) are filtered out since they are not
// hex strings and cannot be converted to a single RGB value.
const BRAND_COLORS_UPPER_CASE_RGB = objectFromEntries(
  objectEntries(DEFAULT_COLORS.brand)
    .filter(([, value]) => typeof value === "string")
    .map(([key, value]) => [capitalizeAll(key), hexToRgb(value as string)])
);

export const COLORS = satisfiesRecord<Color>()({
  INVISIBLE: [0, 0, 0, 0],
  BLUE_40: [0, 0, 255, 40],
  BLUE_50: [0, 0, 255, 50],
  BLUE: [0, 0, 255],
  BLUE_BORDER: [120, 126, 150],
  RED: [255, 0, 0],
  RED_40: [255, 0, 0, 40],
  BLUE_ANALYTIC: [49, 100, 137],
  WHITE: [255, 255, 255],
  ...BRAND_COLORS_UPPER_CASE_RGB,
});

const width = 900 / 3;
const height = 900 / 3;

export const ICON_MAPPING = {
  cancel: { x: 0, y: height * 2, width, height, anchorX: width + width / 3, mask: false },
  cancelNoAnchor: { x: 0, y: height * 2, width, height, mask: false },
  confirm: { x: width, y: height * 2, width, height, anchorX: -width / 3, mask: false },
  confirmNoAnchor: { x: width, y: height * 2, width, height, mask: false },
};
